import { useState } from "react";
import { useParams } from "react-router-dom";

import JournalHeader from "./components/JournalHeader";
import JournalTable from "./components/JournalTable";

const AccountJournals = () => {
  const { id } = useParams();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-8">
        <JournalHeader id={id} refresh={refresh} setRefresh={setRefresh} />
        <JournalTable
          id={id}
          refresh={refresh}
          data={data}
          setData={setData}
          isLoading={isLoading}
          setLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

export default AccountJournals;
